import React from "react";

type ZoomIconProps = {
	size?: number;
};

export const ZoomIcon = ({ size }: ZoomIconProps): React.ReactElement => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={size ?? 48} height={size ?? 48} viewBox="0 0 48 48" fill="none">
			<rect width="48" height="48" rx="8" fill="#2D8CFF" />
			<path
				d="M11 18C11 16.8954 11.8954 16 13 16H26C27.1046 16 28 16.8954 28 18V30C28 31.1046 27.1046 32 26 32H13C11.8954 32 11 31.1046 11 30V18Z"
				fill="#FFFFFF"
			/>
			<path
				d="M37.3536 18.1464C37.6605 17.8395 38.1517 17.7461 38.5557 17.9132C38.9596 18.0804 39.2222 18.4744 39.2222 18.9111V29.0889C39.2222 29.5256 38.9596 29.9196 38.5557 30.0868C38.1517 30.2539 37.6605 30.1605 37.3536 29.8536L30.5 22.9999L37.3536 18.1464Z"
				fill="#FFFFFF"
			/>
		</svg>
	);
};
